import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import OtpVerification from "./auth/otp";
import ResetPassword from "./auth/ResetPassword";
import Dashboard from "./dashboard";
import ManageUser from "./manageUsers";
import ManageUserDetail from "./manageUsers/view";
import ManageSubadmin from "./manageSubadmin";
import ManageNotifications from "./manageNotifications";
import RecievedNotifications from "./recievedNotifications";
import ManageCms from "./manageCms";
import SubadminDetail from "./manageSubadmin/viewSubadmin";
import AddSubadmin from "./manageSubadmin/addSubadmin";
import ManageSubadminRoles from "./manageSubadmin/roles";
import AddRole from "./manageSubadmin/addRole";
import RoleDetail from "./manageSubadmin/viewRole";
import ManageProfile from "./manageProfile";
import EditProfile from "./manageProfile/edit";
import ChangePassword from "./manageProfile/changePassword";
import Edituser from "./manageUsers/add";
import AddNotification from "./manageNotifications/add";
import NotificationDetail from "./manageNotifications/view";
import ManageSubCategories from "./manageCategories/subcategories";
import ManageCategories from "./manageCategories/categories";
import ManageBrands from "./vehicleSpecs/manageBrands";
import ManageFuelType from "./vehicleSpecs/manageFuelType";
import ManageEnginePower from "./vehicleSpecs/manageEnginePower";
import ManageTransmission from "./vehicleSpecs/manageTransmission";
import ManageDriveType from "./vehicleSpecs/manageDriveType";
import ManageEmissionsClass from "./vehicleSpecs/manageEmissionsClass";
import ManageEnvironmentalBadge from "./vehicleSpecs/manageEnvironmentalBadge";
import ManageVehicleType from "./vehicleSpecs/manageVehicleType";
import ManageDamageType from "./vehicleSpecs/manageDamageType";
import ManageColor from "./vehicleSpecs/manageColor";
import ManageModel from "./vehicleSpecs/manageModel";
import ManageDealers from "./manageDealers";
import AddEditDealer from "./manageDealers/add";
import ManageDealersDetail from "./manageDealers/view";
import ManageAnalytics from "./manageAnalytic";
import ManagePackages from "./managePackages";
import AddEditPackage from "./managePackages/add";
import PackageDetail from "./managePackages/view";
import ManageRevenue from "./manageRevenue";
import ManageVehicles from "./manageVehicles";
import ManageSpareParts from "./manageSpareParts";
import AddEditSparePart from "./manageSpareParts/add";
import ManageSparePartsDetail from "./manageSpareParts/view";
import ManageCarAccessories from "./manageCarAccessories";
import AddEditCarAccessory from "./manageCarAccessories/add";
import ManageCarAccessoryDetail from "./manageCarAccessories/view";
import ManageVehicleDetail from "./manageVehicles/view";
import AddEditVehicle from "./manageVehicles/add";
import ManageBlogs from "./manageBlogs";
import AddEditBlog from "./manageBlogs/add";
import ManageCondition from "./vehicleSpecs/manageCondition";
import ManageBlogCategories from "./manageBlogs/categories";
import ManageAxles from "./vehicleSpecs/manageAxles";
import ManageFeatures from "./manageFeatures";
import FeatureGroupDetails from "./manageFeatures/groupDetails";
import BrandDetail from "./vehicleSpecs/manageBrands/view";
import BlogDetail from "./manageBlogs/view";
import ManageVariant from "./vehicleSpecs/manageVariant";
import VariantDetail from "./vehicleSpecs/manageVariant/view";

export default {
  Login,
  ForgotPassword,
  OtpVerification,
  ResetPassword,
  Dashboard,
  ManageUser,
  Edituser,
  ManageUserDetail,
  ManageSubadmin,
  SubadminDetail,
  AddSubadmin,
  ManageSubadminRoles,
  AddRole,
  RoleDetail,
  ManageNotifications,
  AddNotification,
  NotificationDetail,
  RecievedNotifications,
  ManageCms,
  ManageProfile,
  EditProfile,
  ChangePassword,
  ManageAnalytics,
  ManageCategories,
  ManageSubCategories,
  ManageBrands,
  BrandDetail,
  ManageFuelType,
  ManageEnginePower,
  ManageTransmission,
  ManageDriveType,
  ManageEmissionsClass,
  ManageEnvironmentalBadge,
  ManageVehicleType,
  ManageDamageType,
  ManageColor,
  ManageModel,
  ManageAxles,
  ManageCondition,
  ManageDealers,
  AddEditDealer,
  ManageDealersDetail,
  ManagePackages,
  AddEditPackage,
  PackageDetail,
  ManageRevenue,
  ManageVehicles,
  AddEditVehicle,
  ManageVehicleDetail,
  ManageSpareParts,
  AddEditSparePart,
  ManageSparePartsDetail,
  ManageCarAccessories,
  AddEditCarAccessory,
  ManageCarAccessoryDetail,
  ManageBlogs,
  AddEditBlog,
  BlogDetail,
  ManageBlogCategories,
  ManageFeatures,
  FeatureGroupDetails,
  ManageVariant,
  VariantDetail
};
